<template>
  <div class="ppv-filters-header" @click="handleToggle">
    <div class="ppv-filters-left">
      <span class="ppv-filters-title">
        <v-icon class="mr-1">{{ icons.mdiFilterOutline }}</v-icon>
        {{ $t("ppv.filters.title") }}
        <span v-if="activeFilterCount > 0" class="ppv-filters-badge">{{ activeFilterCount }}</span>
      </span>
      <div v-if="!open" class="ppv-filter-summary">
        <span class="ppv-summary-chip">{{ activeDateLabel }}</span>
        <span
          v-if="conditionMode === 'all'"
          class="ppv-summary-chip ppv-summary-chip--condition"
        >
          {{ $t('ppv.filters.risk_assessment_all') }}
        </span>
        <span
          v-for="tr in activeTracks"
          :key="tr"
          class="ppv-summary-chip"
        >
          {{ $t(getTrackLabel(tr)) }}
        </span>
        <span
          v-for="triage in activeTriages"
          :key="triage"
          class="ppv-summary-chip ppv-summary-chip--triage"
        >
          {{ $t(getTriageLabel(triage)) }}
        </span>
      </div>
    </div>
    <span
      v-if="activeFilterCount > 0"
      class="ppv-clear-all"
      @click.stop="handleClear"
    >
      {{ $t("ppv.filters.clear_all") }}
    </span>
    <v-icon class="ppv-chevron" :class="{ open }" size="20">
      {{ icons.mdiChevronRight }}
    </v-icon>
  </div>
</template>

<script>
import icons from '@/mixins/icons'

export default {
  name: 'PpvFilterPanelHeader',
  mixins: [icons],
  props: {
    open: { type: Boolean, required: true },
    activeFilterCount: { type: Number, default: 0 },
    activeDateLabel: { type: String, default: '' },
    activeTracks: { type: Array, default: () => [] },
    activeTriages: { type: Array, default: () => [] },
    conditionMode: { type: String, default: 'user_selected' },
    getTrackLabel: { type: Function, required: true },
    getTriageLabel: { type: Function, required: true },
  },
  emits: ['toggle', 'clear'],
  methods: {
    handleToggle() {
      this.$emit('toggle')
    },
    handleClear() {
      this.$emit('clear')
    },
  },
}
</script>

<style scoped>
.ppv-filters-header {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  cursor: pointer;
  user-select: none;
}
.ppv-filters-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
.ppv-filters-title {
  font-weight: 800;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #1a2340;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.ppv-filters-title .v-icon {
  color: #8a96a8 !important;
  font-size: 22px !important;
}
.ppv-filters-badge {
  background: #5850ec;
  color: #fff;
  font-size: 10px;
  height: 18px;
  width: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
}
.ppv-filter-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.ppv-summary-chip {
  font-size: 12px;
  background: #f0f4f8;
  color: #5a67d8;
  border-radius: 8px;
  padding: 4px 12px;
  font-weight: 700;
  text-transform: capitalize;
}
.ppv-summary-chip--triage {
  background: #fff7ed;
  color: #c2410c;
}
.ppv-summary-chip--condition {
  background: #eef2ff;
  color: #4338ca;
}
.ppv-clear-all {
  font-size: 14px;
  color: #5850ec;
  font-weight: 700;
  margin-right: 18px;
}
.ppv-chevron {
  font-size: 24px;
  color: #a0aec0;
  transition: transform 0.2s;
}
.ppv-chevron.open {
  transform: rotate(180deg);
}
</style>
